import { render } from "./ReasonForm.vue?vue&type=template&id=1da62d80"
import script from "./ReasonForm.vue?vue&type=script&lang=js"
export * from "./ReasonForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__